import React from 'react';
import styled from 'styled-components/macro';
import { CommonTypography } from 'lib/components/styles/typography';
import { FolderOption } from './customOption';
import { Flex } from 'lib/components/styles/layout';

const GroupLabel = styled(CommonTypography).attrs({ as: 'p' })`
  font-size: 11px;
  line-height: 16px;
  font-weight: 600;
  color: ${({ theme }) =>
    theme.colors.secondary?.text || theme.colors.secondary[40]};
  letter-spacing: 0.44px;
  text-transform: uppercase;
  font-variant-numeric-figure: lining-nums;
  font-variant-numeric-spacing: tabular-nums;
`;

export const Divider = styled.div`
  flex-grow: 1;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.neutral[20]};
  margin-left: 8px;
  margin-right: 8px;
`;

export const GroupHeading = (props: {
  data: { label: string; options: FolderOption[] };
}) => {
  if (!props.data?.label?.length) {
    return <></>;
  }

  return (
    <Flex
      padding='0 10px'
      flexDirection='row'
      height='44px'
      alignItems='center'
    >
      <GroupLabel>{props.data.label}</GroupLabel>
      <Divider></Divider>
    </Flex>
  );
};
